import script from "./message-customer-service.vue?vue&type=script&setup=true&lang=ts"
export * from "./message-customer-service.vue?vue&type=script&setup=true&lang=ts"

import "./message-customer-service.vue?vue&type=style&index=0&id=0760d937&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0760d937"]])

export default __exports__